import Link from 'next/link';
import {
    IoAlbumsOutline,
    IoBookOutline,
    IoChatbubbleEllipsesOutline,
    IoCodeSlashOutline,
    IoLinkOutline,
    IoNewspaperOutline,
    IoSchoolOutline,
} from 'react-icons/io5';

import { Box, Group, SimpleGrid, Text } from '@mantine/core';

import { DesignLibraryHelpers } from 'helpers/DesignLibraryHelpers';
import { MarketingHelpers } from 'helpers/MarketingHelpers';

import { DashboardPanel } from 'components/dashboard-panel/DashboardPanel';
import cxPanel from 'components/dashboard-panel/DashboardPanel.module.scss';

const links = [
    { label: 'Documentation', href: MarketingHelpers.urls.docs(), icon: <IoBookOutline /> },
    { label: 'Tutorials', href: MarketingHelpers.urls.tutorials(), icon: <IoSchoolOutline /> },
    { label: 'Product Updates', href: MarketingHelpers.urls.updates(), icon: <IoNewspaperOutline /> },
    { label: 'Reference Designs', href: DesignLibraryHelpers.urls.overview(), icon: <IoAlbumsOutline /> },
    { label: 'Controller Docs', href: MarketingHelpers.urls.controller.documentation(), icon: <IoCodeSlashOutline /> },
    { label: 'Contact Us', href: MarketingHelpers.urls.dcide.contact(), icon: <IoChatbubbleEllipsesOutline /> },
];

const DashboardLinks = () => (
    <DashboardPanel icon={<IoLinkOutline />} color="brand" title="Quick Links">
        <SimpleGrid type="container" cols={{ base: 2, '560px': 3 }} spacing="xs">
            {links.map(({ label, href, icon }) => (
                <Box key={label} component={Link} href={href} className={cxPanel.item}>
                    <Group gap="sm" wrap="nowrap">
                        <Box
                            w={28}
                            c="brand.6"
                            fz={18}
                            display="flex"
                            style={{ justifyContent: 'center', flexShrink: 0 }}
                        >
                            {icon}
                        </Box>
                        <Text size="sm" fw={500} truncate>
                            {label}
                        </Text>
                    </Group>
                </Box>
            ))}
        </SimpleGrid>
    </DashboardPanel>
);

export { DashboardLinks };
